import { useEffect, useState } from 'react';
import { AssetType, preload } from '@/components/Common/Asset';

const usePreloadAsset = (asset: AssetType) => {
  const [isLoading, setIsLoading] = useState(true);

  const handlePreload = async () => {
    setIsLoading(true);
    try {
      await preload(asset);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handlePreload();
  }, [asset]);

  return {
    isLoading,
  };
};

export default usePreloadAsset;
